import { useEffect, useMemo, useState } from 'react';

import { useDataHubClient } from '../../context/DataHubClientContext.js';
import type { AnnotationSchema } from '../../services/dataHubService.interface.js';
import { DataHubService } from '../../services/dataHubService.js';

export interface UseAnnotationSchemasResult {
  schemas: AnnotationSchema[];
  isLoading: boolean;
  error: string | null;
}

export function useAnnotationSchemas(): UseAnnotationSchemasResult {
  const client = useDataHubClient();
  const service = useMemo(() => new DataHubService(client), [client]);

  const [schemas, setSchemas] = useState<AnnotationSchema[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    setIsLoading(true);
    setError(null);

    service
      .listAnnotationSchemas({ pageSize: 100 })
      .then((result) => {
        if (cancelled) return;
        setSchemas(result.items);
        setIsLoading(false);
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setError(
          err instanceof Error
            ? err.message
            : 'Failed to load annotation schemas',
        );
        setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [service]);

  return { schemas, isLoading, error };
}
